import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import filter from 'ramda/es/filter';


const selectDeliveryPoints = createSelector(
  [
    state => state.shop.order.deliveryPoints.data,
    (_, { availableUuids }) => availableUuids,
  ],
  (deliveryPointsArray, availableUuids) => pipe(
    filter(({ uuid }) => !!availableUuids[uuid]),
  )(deliveryPointsArray),
);

export default selectDeliveryPoints;
